import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const titles = {
  "/": "Genel Bakış",
  "/transactions": "Gelir · Gider",
  "/accounts": "Banka Hesapları",
  "/contacts": "Cari Hesaplar",
  "/upcoming": "Ödemeler & Tahsilatlar",
  "/invoices": "Faturalar",
  "/recurring": "Tekrarlayan İşlemler",
  "/reports": "Raporlar",
  "/budgets": "Bütçe & Kategori",
  "/team": "Ekip Üyeleri",
};

export default function Layout() {
  const [mobile, setMobile] = useState(false);
  const [dark, setDark] = useState(() => {
    const v = localStorage.getItem("verafin-theme");
    return v ? v === "dark" : true;
  });
  const loc = useLocation();
  const crumb = titles[loc.pathname] || "VeraFin";

  const toggleDark = () => {
    const next = !dark;
    setDark(next);
    localStorage.setItem("verafin-theme", next ? "dark" : "light");
  };

  return (
    <div className={dark ? "app dark" : "app light"} data-testid="verafin-app">
      <Sidebar open={mobile} onClose={() => setMobile(false)} />
      <main className="main">
        <Topbar crumb={crumb} onOpenMenu={() => setMobile(true)} dark={dark} toggleDark={toggleDark} />
        <div className="content">
          <Outlet />
        </div>
      </main>
      <Toaster
        theme={dark ? "dark" : "light"}
        position="top-right"
        richColors
        closeButton
        toastOptions={{ style: { fontFamily: "Inter, sans-serif" } }}
      />
    </div>
  );
}
